import { Pipe, PipeTransform } from "@angular/core";
import { TB_LEGENDS_COLORS } from "../../entity/color-codes";

@Pipe({
    name: "orderIdColor",
    standalone: false
})
export class OrderIdColorPipe implements PipeTransform {
  transform(orderId: string, isRPProduct?: boolean, isSwedishElectionOrder?: boolean): string {
    if (!orderId) return "";

    if (orderId.startsWith("AP")) {
      return TB_LEGENDS_COLORS.adhoc;
    } else if (orderId.startsWith("RP")) {
      return TB_LEGENDS_COLORS.recurring;
    } 
    if (isRPProduct || isSwedishElectionOrder) {
      return TB_LEGENDS_COLORS.election;
    }
    return "";
  }
}
